import { useLocation } from 'react-router-dom';

import { OVERLAY_PAGE_SEGMENTS, TRACKER_PAGE_SEGMENTS } from '@frontend/constants';

/**
 * Whether the current route is one where the Opal chat overlay may open. Mirrors
 * the overlay's own gate: a segment-membership test against OVERLAY_PAGE_SEGMENTS.
 */
export function useIsOnOverlayPage(): boolean {
  const { pathname } = useLocation();
  const segments = pathname.split('/');
  return OVERLAY_PAGE_SEGMENTS.some(segment => segments.includes(segment));
}

/**
 * Whether the current route is one where the Tracker toggle is available.
 * Mirrors the web TrackerToggleButton's gate (TRACKER_PAGE_SEGMENTS, a wider set
 * than the overlay's). Used to tell the desktop shell when to show its Tracker
 * button.
 */
export function useIsOnTrackerPage(): boolean {
  const { pathname } = useLocation();
  const segments = pathname.split('/');
  return TRACKER_PAGE_SEGMENTS.some(segment => segments.includes(segment));
}
